import { capitalizeString } from './capitalizeString';

export const prepareSelectLabel = (label) => capitalizeString(label.replace(/_/g, ' '));
